import { useAppSelector } from 'utils/redux/useAppSelector';
import { hasFeature } from './hasFeature';
export const useHasFeature = (name) => {
    return useAppSelector((state) => hasFeature(state, name));
};
